import React, { useState } from "react";
import { use } from "react";
import { Modal, Button, Form, Nav } from "react-bootstrap";
import AddContactModal from "./AddContactModal";
import AddEditDealModal from "./AddEditDealModal";

export default function EditCompanyModal({ show, setShow }) {
  const [activeTab, setActiveTab] = useState("basic");
  const [preview, setPreview] = useState("/assets/img/profiles/avatar-14.jpg");
  const [addNew, setAddNew] = useState(false); // for Deal modal
  const [addNewContact, setAddNewContact] = useState(false); // for Contact modal
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPreview(URL.createObjectURL(file));
    }
  };

  return (
    <Modal show={show} onHide={() => setShow(false)} centered size="lg">
      {/* HEADER */}
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="fw-semibold">Edit New Company</Modal.Title>
      </Modal.Header>

      {/* TABS */}
      <div className="px-3 pt-2 border-bottom">
        <Nav
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k)}
          className="custom-tabs"
        >
          <Nav.Item>
            <Nav.Link eventKey="basic">Basic Information</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="address">Address</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="social">Social Profiles</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="access">Access</Nav.Link>
          </Nav.Item>
        </Nav>
      </div>

      <Modal.Body className="pt-3">
        {activeTab === "basic" && (
          <>
            {/* UPLOAD */}
            <div className="upload-box d-flex align-items-center mb-4">
              <img src={preview} className="upload-avatar me-3" />

              <div>
                <div className="fw-semibold">Upload Profile Image</div>
                <div className="text-muted small mb-2">
                  Image should be below 4 mb
                </div>

                <input
                  type="file"
                  hidden
                  id="upload"
                  onChange={handleImageUpload}
                />

                <label htmlFor="upload" className="btn btn-orange btn-sm me-2">
                  Upload
                </label>

                <Button size="sm" variant="light">
                  Cancel
                </Button>
              </div>
            </div>

            {/* FORM */}
            <div className="row g-3">
              <div className="col-md-6">
                <Form.Label>
                  Company Name <span className="req">*</span>
                </Form.Label>
                <Form.Control defaultValue="BrightWave Innovations" />
              </div>

              <div className="col-md-6">
                <Form.Label>Email</Form.Label>
                <Form.Control defaultValue="darlee@example.com" />
              </div>

              <div className="col-md-6">
                <Form.Label>
                  Phone Number <span className="req">*</span>
                </Form.Label>
                <Form.Control defaultValue="(146) 1249 296" />
              </div>

              <div className="col-md-6">
                <Form.Label>Phone Number 2</Form.Label>
                <Form.Control defaultValue="(146) 1249 321" />
              </div>

              <div className="col-md-6">
                <Form.Label>Fax</Form.Label>
                <Form.Control />
              </div>

              <div className="col-md-6">
                <Form.Label>Website</Form.Label>
                <Form.Control />
              </div>

              <div className="col-md-6">
                <Form.Label>
                  Reviews <span className="req">*</span>
                </Form.Label>
                <Form.Control defaultValue="4.5" />
              </div>

              <div className="col-md-6">
                <Form.Label>
                  Owner <span className="req">*</span>
                </Form.Label>
                <Form.Select>
                  <option>Vamsi</option>
                  <option>Arif</option>
                  <option>Revanth</option>
                  <option>Sai</option>
                </Form.Select>
              </div>

              <div className="col-md-6">
                <Form.Label>
                  Tags <span className="req">*</span>
                </Form.Label>
                <Form.Control defaultValue="Collab" />
              </div>

              <div className="col-md-6 position-relative">
                <Form.Label>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "16px",
                    }}
                  >
                    {/* Left side - Deals + required star */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <span>Deals</span>
                      <span style={{ color: "red", fontWeight: "bold" }}>
                        *
                      </span>
                    </div>

                    {/* Right side - + Add New pushed to the right */}
                    <h6
                      onClick={() => setAddNew(true)}
                      style={{
                        margin: 0,
                        color: "#eb6c1d", // Bootstrap primary blue (or change to your color)

                        cursor: "pointer",
                        marginLeft: "auto", // this pushes it to the right
                        paddingLeft: "230px", // adds extra space from the left content
                      }}
                    >
                      + Add New
                    </h6>
                  </div>
                </Form.Label>
                <Form.Select>
                  <option>Collins</option>
                  <option>Deal 1</option>
                </Form.Select>
              </div>

              <div className="col-md-6">
                <Form.Label>
                  Industry <span className="req">*</span>
                </Form.Label>
                <Form.Select>
                  <option>Retail</option>
                  <option>Banking</option>
                  <option>Hotels</option>
                  <option>Financial Services</option>
                  <option>Insurance</option>
                </Form.Select>
              </div>

              <div className="col-md-6">
                <Form.Label>
                  Source <span className="req">*</span>
                </Form.Label>
                <Form.Select>
                  <option>Phone Calls</option>
                  <option>Referral</option>
                  <option>Staff</option>
                  <option>Web Analysis</option>
                  <option>Previous Purchase</option>
                </Form.Select>
              </div>

              <div className="col-md-6">
                <Form.Label>
                  Currency <span className="req">*</span>
                </Form.Label>
                <Form.Select>
                  <option>Dollar</option>
                  <option>Euro</option>
                  <option>Rupee</option>
                </Form.Select>
              </div>

              <div className="col-md-6">
                <Form.Label>
                  Language <span className="req">*</span>
                </Form.Label>
                <Form.Select>
                  <option>English</option>
                  <option>Telugu</option>
                  <option>Hindi</option>
                </Form.Select>
              </div>

              <div className="col-12">
                <Form.Label>
                  About <span className="req">*</span>
                </Form.Label>
                <Form.Control as="textarea" rows={3} />
              </div>

              {/* CONTACT */}
              <div className="col-12">
                <Form.Label>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "16px",
                    }}
                  >
                    {/* Left side - Deals + required star */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <span>Contact</span>
                      <span style={{ color: "red", fontWeight: "bold" }}>
                        *
                      </span>
                    </div>

                    {/* Right side - + Add New pushed to the right */}
                    <h6
                      onClick={() => setAddNewContact(true)}
                      style={{
                        margin: 0,
                        color: "#eb6c1d", // Bootstrap primary blue (or change to your color)

                        cursor: "pointer",
                        marginLeft: "auto", // this pushes it to the right
                        paddingLeft: "600px", // adds extra space from the left content
                      }}
                    >
                      + Add New
                    </h6>
                  </div>
                </Form.Label>

                <div className="contact-box">
                  <span className="tag">Sharon Roy ✕</span>
                  <span className="tag">Vaughan ✕</span>
                </div>
              </div>
            </div>
          </>
        )}

        {/* OTHER TABS */}
        {activeTab === "address" && (
          <div className="py-4 text-center">Address Tab</div>
        )}
        {activeTab === "social" && (
          <div className="py-4 text-center">Social Profiles</div>
        )}
        {activeTab === "access" && (
          <div className="py-4 text-center">Access</div>
        )}
      </Modal.Body>

      {/* FOOTER */}
      <Modal.Footer className="border-0">
        <Button variant="light" onClick={() => setShow(false)}>
          Cancel
        </Button>
        <Button className="btn-orange">Save</Button>
      </Modal.Footer>
      <AddContactModal show={addNewContact} setShow={setAddNewContact} />
      <AddEditDealModal show={addNew} setShow={setAddNew} />
      {/* STYLES */}
      <style>{`
        .req { color: red; }

        .custom-tabs .nav-link {
          color: #777;
          padding: 10px 12px;
        }

        .custom-tabs .nav-link.active {
          color: #f26522;
          border-bottom: 2px solid #f26522;
        }

        .btn-orange {
          background: #f26522;
          border: none;
        }

        .upload-box {
          border: 1px dashed #e5e5e5;
          padding: 15px;
          border-radius: 8px;
          background: #fafafa;
        }

        .upload-avatar {
          width: 55px;
          height: 55px;
          border-radius: 50%;
          object-fit: cover;
        }

        .add-new {
          float: right;
          font-size: 12px;
          color: #f26522;
          cursor: pointer;
        }

        .contact-box {
          border: 1px solid #ddd;
          padding: 8px;
          border-radius: 6px;
        }

        .tag {
          background: #f1f1f1;
          padding: 4px 8px;
          border-radius: 4px;
          margin-right: 5px;
        }

        .form-control,
        .form-select {
          height: 38px;
        }

        .form-control:focus,
        .form-select:focus {
          border-color: #f26522;
          box-shadow: none;
        }
      `}</style>
    </Modal>
  );
}
